import gql from 'graphql-tag'

export default gql`
query searchTrackings($code: String!) {
  trackings(
    filter: {
      code: $code
    }
  ) {
    _id
    carrier
    code
    scannedAt
    status
    label {
      _id
      referenceId
      seq
      last
      data
      recipient
      address
      app
      group
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/searchTrackings.js